import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, } from '@angular/core';
import { ProfileService } from 'src/app/_services/profile.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ModificaPasswordComponent } from '../../profilo-utente/modifica-password/modifica-password.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { UtilityService } from 'src/app/_services/utility.service';
import { DashboardComponent } from '../../dashboard.component';
import { environment } from 'src/environments/environment';
import { ProfiloUtenteComponent } from '../../profilo-utente/profilo-utente.component';

const envStorage = `${environment.file}`;

@Component({
  selector: 'app-card-dati-generali',
  templateUrl: './card-dati-generali.component.html',
  styleUrls: ['./card-dati-generali.component.css'],
})
export class CardDatiGeneraliComponent implements OnInit, OnChanges {
  roles: any;
  profileName: any;
  profileSurname: any;
  profileEmail: any;
  profilePic: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  readyFile: any = '';
  profilePicSelected: any;

  @Input('profileData') profileData: any;

  @ViewChild('profileImage') profileImage: ElementRef;
  projectPicSelected: string;
  base64result: any;

  constructor(
    private dialog: MatDialog,
    private profileService: ProfileService,
    private ProfiloUtenteComponent: ProfiloUtenteComponent,
    public utilityService: UtilityService,
    private dashboardComponent: DashboardComponent,
    private sanitizer: DomSanitizer,) { }

    async ngOnInit(): Promise<void> {
      let user = await this.profileService.getUserRoleAsync();
      this.roles = user.roles[0].name;
  }


  ngOnChanges(changes: SimpleChanges): void {
    // this.roles = this.profileData.roles[0].name;

    if (this.profileData) {
      this.profileName = this.profileData.first_name;
      this.profileSurname = this.profileData.last_name;
      this.profileEmail = this.profileData.email;
      this.profilePic = this.profileData.filestorage.path;
    }
  }

  fileChangeEvent(event: any): void {
    const file: any = event.target.files[0];
    this.readyFile = file;
    this.handleInputChange(file);
  }

  async handleInputChange(file: any) {
    const pattern = /image-*/;
    const reader = new FileReader();

    if (!file.type.match(pattern)) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        icon: 'error',
        iconColor: '#FFB26B',
        title: "Formato dell'immagine non valida",
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });
      return;
    }

    const maxSizeInBytes = 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      // Ridimensiona l'immagine se supera il limite
      await this.resizeAndHandleInputChange(file, maxSizeInBytes);
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
    this.projectPicSelected = URL.createObjectURL(file);
  }

  async resizeAndHandleInputChange(
    file: any,
    maxSizeInBytes: number
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const img = new Image();
        img.onload = () => {
          const scaleFactor = maxSizeInBytes / file.size; // Calcola il fattore di scala
          const width = img.width * scaleFactor;
          const height = img.height * scaleFactor;
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0, width, height);
            // Ottieni l'URL dell'immagine ridimensionata
            const resizedImageUrl = canvas.toDataURL('image/jpeg', 1);
            // Mostra l'immagine ridimensionata
            this.projectPicSelected = resizedImageUrl;
            resolve();
          } else {
            console.error('Contesto canvas non disponibile');
            reject('Contesto canvas non disponibile');
          }
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  async _handleReaderLoaded(e: any) {
    const reader = e.target;
    this.base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.saveProfilePic(this.base64result);
    await this.profileService.getProfile();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded(image: LoadedImage) {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  saveProfilePic(file: any) {
    const formData = new FormData();
    formData.append('file_img', this.readyFile);

    this.profileService
      .saveProfilePic(formData, this.profileData.id)
      .subscribe({
        next: (value) => {
          this.ProfiloUtenteComponent.getProfileData();
          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title: 'Immagine profilo aggiornata',
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });
        this.profileService.reloadProfile();
      },
      error: error => {
        console.error(error);
      }
    });
  }

  editPassword() {
    const dialogRef = this.dialog.open(ModificaPasswordComponent, {
      width: '600px',
    });
  }

  public getSantizeUrl(url: string) {
    if (url === null) {
      url = `${envStorage}/users/profile/default.jpeg`;
    } else {
      let image = this.sanitizer.bypassSecurityTrustUrl(url);
    }

    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
